<template>
  <!-- -->
  <div class="date_weather" v-if="timeFlag">
    <div class="date_main">
      <!-- 时间内容 -->
      <div class="time_cont" v-show="TimeContent">
        <div class="time_top">
          <!-- 时间实时开关 -->
          <div class="text">时间实时开关</div>
          <!-- <div class="timing"></div> -->
          <div class="timing_but">
            <span>{{ defTime }}</span>
            <el-switch @change="timeChange" v-model="timingTimeButton"></el-switch>
          </div>
        </div>

        <!-- 时间滑块 -->
        <div class="time_slider" :class="timingTimeButton ? 'forbid' : ''">
          <div class="time_num">
            <div
              v-for="(item, index) in timeSliderNum"
              :key="index"
              :class="'item_time' + index"
            >{{ item }}</div>
          </div>
          <div class="slider">
            <el-slider
              v-model="timeSlider"
              :max="1440"
              :format-tooltip="sliderLabel"
              :disabled="timingTimeButton"
              @change="sliderTiemChange"
              :debounce="300"
            ></el-slider>
            <div class="sliderBox" v-if="0">
              <input type="range" :min="0" :max="1440" :value="60" :oninput="sliderTiemChange" />
            </div>
          </div>
        </div>
        <!-- 时间图标 -->
        <div class="time_icon" :class="timingTimeButton ? 'forbid' : ''">
          <div
            class="icon_item"
            v-for="(item, index) in timeIcon"
            :key="index"
            @click="timeIconActive(item, index)"
          >
            <div class="item_icon">
              <img v-if="!item.flag" :src="item.icon + '.png'" alt />
              <img v-else :src="item.icon + '-2.png'" alt />
            </div>
            <div class="item_text" :class="item.flag ? 'text_active' : ''">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="line" v-show="TimeContent"></div>
      <!-- 天气内容 -->
      <div class="weather_cont" v-show="WeatherContent">
        <div class="weather_top">
          <!-- 天气实时开关 -->
          <div class="text">天气实时开关</div>
          <div class="wea_condition">
            <img :src="realWeather.icon + '-2.png'" alt />
          </div>
          <div class="weather_but">
            <div class="but_text">{{ realWeather.text }}</div>
            <el-switch v-model="timingWeatherButton" @change="weatherChange"></el-switch>
          </div>
        </div>
        <div class="weather_icon" :class="timingWeatherButton ? 'forbid' : ''">
          <div
            class="ionc_item"
            v-for="(item, index) in weatherIcon"
            :key="index"
            @click="weatherIconActive(item, index)"
          >
            <div class="item_icon">
              <img v-if="!item.flag" :src="item.icon + '.png'" alt />
              <img v-else :src="item.icon + '-2.png'" alt />
            </div>
            <div class="item_text" :class="item.flag ? 'text_active' : ''">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="line" v-show="SeasonalContent&&WeatherContent"></div>
      <!-- 季节实时开关 -->
      <div class="xjsskg" v-show="SeasonalContent">
        <div class="xjsskg_top">
          <!-- 季节实时开关 -->
          <div class="text">季节实时开关</div>
          <div class="xjsskg_but">
            <span v-if="xjButton || season">{{ season }}</span>
            <el-switch @change="xjChange" v-model="xjButton"></el-switch>
          </div>
        </div>
        <div class="xjsskg_cont" :class="xjButton ? 'forbid' : ''">
          <div
            class="item_xjsskg"
            v-for="(item, index) in jjsskgImg"
            :key="index"
            @click="seasonEvent(item, index)"
          >
            <div class="item_img">
              <img v-if="item.flag" :src="item.icon + '2.png'" alt />
              <img v-else :src="item.icon + '.png'" alt />
            </div>
            <div class="item_text" :class="item.flag ? 'item_text_ac' : ''">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Time from '../../utils/common/time'
import Environment from '../../utils/UEapi/Environment'
import { mapState } from 'vuex'
import RangeSlider from '@/utils/RangeSlider'
export default {
  props: {
    timeFlag: {
      type: Boolean,
      default: false
    },
    // 时间内容
    TimeContent: {
      type: Boolean,
      default: true
    },
    // 天气内容
    WeatherContent: {
      type: Boolean,
      default: true
    },
    // 季节内容
    SeasonalContent: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      now: null,
      day: null,
      time: null,
      month: null,
      // 实时时间按钮
      timingTimeButton: false,
      // 时间滑块数值
      timeSliderNum: [0, 6, 12, 18, 24],
      //   时间滑块
      timeSlider: 420,
      //   时间图标
      timeIcon: [
        {
          text: '早晨',
          icon: '/img/weather/Time-早晨',
          flag: false,
          English: 'Morning'
        },
        {
          text: '中午',
          icon: '/img/weather/Time-中午',
          flag: false,
          English: 'Noon'
        },
        {
          text: '黄昏',
          icon: '/img/weather/Time-黄昏',
          flag: false,
          English: 'Dusk'
        },
        {
          text: '傍晚',
          icon: '/img/weather/Time-傍晚',
          flag: false,
          English: 'Evening'
        },
        {
          text: '夜晚',
          icon: '/img/weather/Time-夜晚',
          flag: false,
          English: 'Night'
        }
      ],
      //   实时天气按钮
      timingWeatherButton: false,
      // 天气图标
      weatherIcon: [
        {
          text: '晴',
          icon: '/img/weather/Weather-晴',
          flag: true,
          English: 'Sunny'
        },
        {
          text: '小雨',
          icon: '/img/weather/Weather-小雨',
          flag: false,
          English: 'Light Rain'
        },
        {
          text: '小雪',
          icon: '/img/weather/Weather-小雪',
          flag: false,
          English: 'Light Snow'
        },
        {
          text: '雾',
          icon: '/img/weather/Weather-雾',
          flag: false,
          English: 'Fog'
        },
        {
          text: '晴间多云',
          icon: '/img/weather/Weather-晴间多云',
          flag: false,
          English: 'Fine with Occasional Clouds'
        },
        {
          text: '中雨',
          icon: '/img/weather/Weather-中雨',
          flag: false,
          English: 'Moderate Rain'
        },
        {
          text: '中雪',
          icon: '/img/weather/Weather-中雪',
          flag: false,
          English: 'Moderate Snow'
        },
        {
          text: '扬沙',
          icon: '/img/weather/Weather-扬沙',
          flag: false,
          English: 'Sand Blowing'
        },
        {
          text: '阴天',
          icon: '/img/weather/Weather-阴天',
          flag: false,
          English: 'Overcast'
        },
        {
          text: '大雨',
          icon: '/img/weather/Weather-大雨',
          flag: false,
          English: 'Heavy Rain'
        },
        {
          text: '大雪',
          icon: '/img/weather/Weather-大雪',
          flag: false,
          English: 'Heavy Snow'
        },
        {
          text: '霾',
          icon: '/img/weather/Weather-霾',
          flag: false,
          English: 'Smog'
        }
      ],
      //显示的天气图片
      defIcon: '/img/weather/Weather-中雨',
      defTime: '07:00',
      weathers: {
        晴: 'Sunny',
        晴间多云: 'PartlyCloudy',
        阴天: 'Overcast',
        小雨: 'LightRain',
        中雨: 'ModerateRain',
        大雨: 'HeavyRain',
        小雪: 'LightSnow',
        中雪: 'ModerateSnow',
        大雪: 'HeavySnow',
        雾: 'Foggy',
        扬沙: 'Dust',
        霾: 'Haze'
      },
      times: {
        早晨: '07:00',
        中午: '12:00',
        黄昏: '17:00',
        傍晚: '17:09',
        夜晚: '20:00'
      },
      // 计时器
      interTime: null,
      // 季节实时开关
      jjsskgImg: [
        {
          text: '春季',
          value: 'Spring',
          icon: '/img/weather/春季',
          flag: false,
          English: 'Spring'
        },
        {
          text: '夏季',
          value: 'Summer',
          icon: '/img/weather/夏季',
          flag: false,
          English: 'Summer'
        },
        {
          text: '秋季',
          value: 'Autumn',
          icon: '/img/weather/秋季',
          flag: false,
          English: 'Autumn'
        },
        {
          text: '冬季',
          value: 'Winter',
          icon: '/img/weather/冬季',
          flag: false,
          English: 'Winter'
        }
      ],
      season: '',
      // 夏季
      xjButton: false,
      realWeather: {
        text: '晴',
        icon: '/img/weather/Weather-晴',
        English: 'Sunny'
      }
    }
  },
  created() {
    this.initDay()
  },
  methods: {
    // 滑块label 对应时间
    sliderLabel(value) {
      let hh =
        parseInt((value * 24) / 1440) > 9
          ? parseInt((value * 24) / 1440)
          : '0' + parseInt((value * 24) / 1440)
      let mm =
        parseInt(value % 60) > 9
          ? parseInt(value % 60)
          : '0' + parseInt(value % 60)
      value = hh + ':' + mm
      this.defTime = value
      return value
    },
    closeTime() {
      this.$emit('closeTime')
    },
    // 时间按钮
    timeChange(val) {
      if (val) {
        this.timeIcon.forEach(item => {
          item.flag = false
        })
        this.realTime()
      } else {
        clearInterval(this.interTime)
        this.interTime = null
      }
    },
    // 季节实时开关
    xjChange(val) {
      if (val) {
        this.jjsskgImg.forEach(item => (item.flag = false))
        let seasonObj = null
        switch (this.month) {
          case '3':
          case '4':
          case '5':
            seasonObj = 'Spring'
            this.season = '春季'
            break
          case '6':
          case '7':
          case '8':
            seasonObj = 'Summer'
            this.season = '夏季'
            break
          case '9':
          case '10':
          case '11':
            seasonObj = 'Autumn'
            this.season = '秋季'
            break
          case '12':
          case '1':
          case '2':
            seasonObj = 'Winter'
            this.season = '冬季'
            break
        }
        Environment.playAnimation(seasonObj)
      } else {
        // this.season = ''
        Environment.playAnimation('Spring')
      }
    },
    // 季节切换
    seasonEvent(item, index) {
      if (this.xjButton) {
        return
      }
      if (item.flag) {
        item.flag = false
        // this.season = ''
        Environment.playAnimation('Spring')
      } else {
        this.jjsskgImg.forEach(item => (item.flag = false))
        item.flag = true
        // this.season = item.text
        this.season = item.text
        Environment.playAnimation(item.value)
      }
    },
    // 天气按钮
    weatherChange(val) {
      if (val) {
        this.weatherIcon.forEach(item => {
          item.flag = false
        })
      }
    },
    // 点击时间图标高亮
    timeIconActive(item, index) {
      if (!this.timingTimeButton) {
        this.timeIcon.forEach(item => {
          item.flag = false
        })
        this.timeIcon[index].flag = true
        this.defTime = this.times[item.text]
        this.correspondingTime(this.defTime, false)
        this.$store.commit('setSceneTime', this.times[item.text])
      }
    },
    // 点击天气图标高亮
    weatherIconActive(item, index) {
      if (!this.timingWeatherButton) {
        this.weatherIcon.forEach(item => {
          item.flag = false
        })
        this.weatherIcon[index].flag = true
        this.realWeather = item
        this.$store.commit('setSceneWeather', this.weathers[item.text])
      }
    },
    //时间滑块
    sliderTiemChange() {
      this.$store.commit('setSceneTime', this.defTime)
    },
    // 获取时间戳
    initDay() {
      this.now = new Date()
      this.week = Time.getWeek(this.now)
      this.day = Time.format('yyyy-MM-dd', this.now)
      this.time = Time.format('HH:mm:ss', this.now)
      this.month = Time.format('M', this.now)
    },
    // 实时时间
    realTime() {
      let evnTime = new Date().format('hh:mm')
      this.$store.commit('setSceneTime', evnTime)
      this.defTime = evnTime
      this.correspondingTime(evnTime, true)
      this.interTime = setInterval(() => {
        this.defTime = evnTime
        let evnTime = new Date().format('hh:mm')
        this.$store.commit('setSceneTime', evnTime)
        this.correspondingTime(evnTime, true)
      }, 1000 * 60)
    },
    //  数值对应的时间
    correspondingTime(evnTime, flag) {
      let arr = evnTime.split(':')
      if (flag) {
        this.timeSlider = arr[0] * 60 + parseInt(arr[1] / 6)
      } else {
        this.timeSlider = arr[0] * 60 + parseInt(arr[1])
      }
    }
  },
  mounted() {
    switch (this.month) {
      case '3':
      case '4':
      case '5':
        this.season = '春季'
        break
      case '6':
      case '7':
      case '8':
        this.season = '夏季'
        break
      case '9':
      case '10':
      case '11':
        this.season = '秋季'
        break
      case '12':
      case '1':
      case '2':
        this.season = '冬季'
        break
    }
  },
  watch: {
    sceneTime: {
      handler(val) {
        let date = val.slice(0, 2)
        this.timeSlider = date * 60
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['sceneTime'])
  }
}
</script>

<style lang="less" scoped>
.date_weather {
  position: absolute;
  top: 85px;
  right: 46px;
  width: 320px;
  // height: 570px;
  pointer-events: all;
  background: rgba(15, 26, 36, 0.8);
  border: solid 1px rgba(38, 255, 255, 0.6);
  box-sizing: border-box;
  padding-bottom: 20px;
  .date_main {
    width: 100%;
    padding-top: 15px;
    box-sizing: border-box;
    .time_cont {
      width: 100%;
      height: 114px;
      padding: 0px 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 20px;
      .time_top {
        width: 98%;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text {
          font-family: 'Helvetica';
          font-size: 14px;
          color: #cacad8;
        }
        .timing {
          width: 80px;
        }
        .timing_but {
          height: 100%;
          display: flex;
          align-items: center;
          span {
            font-family: 'Arial';
            font-size: 14px;
            color: #cacad8;
            margin-right: 20px;
          }
          /deep/ .el-switch {
            .el-switch__core::after {
              width: 18px;
              height: 18px;
              top: 0px;
            }
          }
        }
      }
      .time_slider {
        width: 100%;
        height: 28px;
        .time_num {
          width: 100%;
          font-family: 'Arial';
          font-size: 14px;
          color: #cacad8;
          display: flex;
          justify-content: space-between;
          align-content: center;
        }
        .slider {
          width: 100%;
          /deep/.el-slider__runway {
            margin: 0px;
          }

          /deep/.el-slider__runway {
            background: rgba(255, 255, 255, 0.2);
          }

          /deep/.el-slider__button-wrapper {
            width: 4px;
            height: 4px;
            top: -10px;
          }

          /deep/.el-slider__button {
            width: 4px;
            height: 4px;
            box-shadow: 0px 0px 10px 5px #0a7acd;
          }
        }
        .sliderBox {
          height: 10px;
          cursor: pointer;
          input {
            width: 100%;
          }
          input[type='range'] {
            -webkit-appearance: none;

            border-radius: 10px; /*这个属性设置使填充进度条时的图形为圆角*/
          }
          input[type='range']::-webkit-slider-thumb {
            -webkit-appearance: none;
          }
          input[type='range']::-webkit-slider-runnable-track {
            height: 10px;
            box-shadow: 0 1px 1px #def3f8, inset 0 0.125em 0.125em #0d1112; /*轨道内置阴影效果*/
          }
          input[type='range']:focus {
            outline: none;
          }
          input[type='range']::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 25px;
            width: 25px;
            margin-top: -5px; /*使滑块超出轨道部分的偏移量相等*/
            background: #ffffff20;
            border-radius: 50%; /*外观设置为圆形*/
            box-shadow: 0px 0px 10px 5px #0a7acd;
          }
        }
      }
      .time_icon {
        width: 100%;
        height: 51px;
        display: flex;
        justify-content: space-between;
        .icon_item {
          width: 56px;
          height: 51px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          .item_icon {
            width: 44px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            img {
              vertical-align: middle;
            }
          }
          .item_text {
            width: 56px;
            text-align: center;
            font-size: 14px;
            font-family: 'Helvetica';
            color: #cacad8;
          }
          .text_active {
            color: #ffffff;
            text-shadow: -2px 2px 8px #26c9ff;
          }
        }
      }
    }
    .line {
      margin: 0 auto;
      width: 280px;
      height: 1px;
      background: rgba(255, 255, 255, 0.3);
    }
    .weather_cont {
      width: 100%;
      height: 279px;
      margin-bottom: 15px;

      .weather_top {
        width: 100%;
        height: 54px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px 0px 20px;
        box-sizing: border-box;
        .text {
          width: 123px;
          font-family: 'Helvetica';
          font-size: 14px;
          color: #cacad8;
        }
        .wea_condition {
          width: 44px;
          text-align: right;
          img {
          }
        }
        .weather_but {
          font-family: 'Helvetica';
          font-size: 14px;
          color: #777777;
          width: 112px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .but_text {
            width: 58px;
            text-align: center;
          }
          /deep/ .el-switch {
            .el-switch__core::after {
              width: 18px;
              height: 18px;
              top: 0px;
            }
          }
        }
      }
      .weather_icon {
        width: 100%;
        height: 225px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
        .ionc_item {
          width: 79px;
          height: 67px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .item_icon {
            width: 44px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            img {
              vertical-align: middle;
            }
          }
          .item_text {
            text-align: center;
            font-size: 14px;
            font-family: 'Helvetica';
            color: #cacad8;
          }
          .text_active {
            color: #ffffff;
            text-shadow: -2px 2px 8px #26c9ff;
          }
        }
      }
    }
    .xjsskg {
      width: 100%;
      .xjsskg_top {
        width: 98%;
        height: 53px;
        padding: 15px 20px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text {
          width: 133px;
          font-family: 'Helvetica';
          font-size: 14px;
          color: #cacad8;
        }
        .xjsskg_but {
          width: 112px;
          height: 38px;
          display: flex;
          align-items: center;
          span {
            width: 133px;
            font-family: 'Helvetica';
            font-size: 14px;
            color: #cacad8;
            margin-right: 20px;
          }
          /deep/ .el-switch {
            .el-switch__core::after {
              width: 18px;
              height: 18px;
              top: 0px;
            }
          }
        }
      }
      .xjsskg_cont {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .item_xjsskg {
          width: 62px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .item_img {
            width: 44px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            img {
              vertical-align: middle;
            }
          }
          .item_text {
            width: 62px;
            text-align: center;
            font-family: 'Helvetica';
            font-size: 14px;
            color: #cacad8;
          }
          .item_text_ac {
            color: #fff;
            text-shadow: 0px 0px 8px #0080ff;
          }
        }
      }
    }
  }
  .forbid {
    cursor: not-allowed;
  }
}
</style>
